export const FETCH_QUICK_STATS = "DASHBOARD/FETCH_QUICK_STATS";
export const FETCH_QUICK_STATS_SUCCESS = "DASHBOARD/FETCH_QUICK_STATS_SUCCESS";
export const FETCH_QUICK_STATS_FAILURE = "DASHBOARD/FETCH_QUICK_STATS_FAILURE";

export const SET_FILTER_MERCHANT_VALUE  = "DASHBOARD/SET_FILTER_MERCHANT_VALUE";
export const SET_FILTER_STORE_VALUE  = "DASHBOARD/SET_FILTER_STORE_VALUE";

export const FETCH_PENDING_ORDERS = "DASHBOARD/FETCH_PENDING_ORDERS";
export const FETCH_PENDING_ORDERS_SUCCESS = "DASHBOARD/FETCH_PENDING_ORDERS_SUCCESS";
export const FETCH_PENDING_ORDERS_FAILURE = "DASHBOARD/FETCH_PENDING_ORDERS_FAILURE";

